import React from 'react'

const visionmissionAPI = [
    {
        img:"./assets/images/aboutpage/visionmission/1.png",
        subheading:"VISION",
        heading:"OUR VISION IS TO DELIVER THE KNOWLEDGE OF THE QURAN",
        paragraph:"Our vision is to deliver the knowledge of the Quran and Hadith with their essence to all Bengali Speaking people by the year 2040.",
        flip:false,
        list:false
    },
    {
        img:"./assets/images/aboutpage/visionmission/2.png",
        subheading:"MISSION",
        heading:"OUR MISSION IS TO ATTAIN BLESSINGS AND THE PLEASURE OF",
        paragraph:"Our mission is to attain blessings and the pleasure of Allah the Al-Mighty by conveying His message of Quran to Bengali Speaking People",
        flip:true,
        list:false
    },
    {
        img:"./assets/images/aboutpage/visionmission/3.png",
        subheading:"AIM",
        heading:"EVERY MUSLIM RECOGNIZES THE IMPORTANCE OF LEARNING THE",
        paragraph:"Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. Tarbyiah Institute is established with the aim to spread the knowledge of the Quran, especially among those where there are no reliable resources for learning the Quran.",
        flip:false,
        list:false
    },
    {
        img:"./assets/images/aboutpage/visionmission/4.png",
        subheading:"OBJECTIVE",
        heading:"CULTIVATE AND EDUCATE MUSLIMS WITH THE KNOWLEDGE QURAN",
        paragraph:"Our vision is to deliver the knowledge of the Quran and Hadith with their essence to all Bengali Speaking people by the year 2040.",
        flip:true,
        list:true
    },
]

const VisionMissionAPI = () => {
  return (
    <>

    </>
  )
}

export {visionmissionAPI}

export default VisionMissionAPI